import { actionCreator } from '../../utils/actions';

export const toggleMoreModal = actionCreator('MODAL/TOGGLE_MORE_MODAL');
export const togglePaymentModal = actionCreator('MODAL/TOGGLE_PAYMENT_MODAL');
export const toggleSettingsModal = actionCreator('MODAL/TOGGLE_SETTINGS_MODAL');

export const changeCurrentVehicle = actionCreator('MODAL/CHANGE_CURRENT_VEHICLE');
export const switchCurrentDevice = actionCreator('MODAL/CHANGE_CURRENT_DEVICE');



// WEBPACK FOOTER //
// ./src/components/Modal/actions.js